import { render, staticRenderFns } from "./CreateProjectLeadsModal.vue?vue&type=template&id=2310039e&"
import script from "./CreateProjectLeadsModal.vue?vue&type=script&lang=js&"
export * from "./CreateProjectLeadsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports